<div class="vertical-bar-simple-chart">
  <div *ngIf="isBrowser && showChart"
       echarts
       [options]="chartOption"
       (chartInit)="onChartInit($event)"
       class="chart-container">
  </div>
</div>
